import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SoProductionDTO } from './dto/so-production.dto';


export class SoProductionResponseModel extends GlobalResponseObject {
    data?: SoProductionDTO;
    /** 
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SoProductionDTO){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

